import { FormFieldsGeneratorService } from './../../form-helpers/form-fields-generator.service';
import { DeliveryMode, IdentityConfirmationMode } from '../../../interfaces/paymentAndDelivery.interface';
import { IPrice } from './../../../interfaces/cart-details.interface';
import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { DeliveryFormOutputState, DeliveryFormStateService } from '../../form-state/delivery-form-state.service';
import { DeliveryModalService, PosInterface } from './pos/delivery-modal.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../../external-interfaces/notification-provider.service';
import { UiHelperService } from '../../../utils/services/ui-helper.service';
import { CommonInfoService } from '../../../cart-process/common-info.service';
import { DeliveryPickupService } from '../delivery-pickup.service';
import { FormStateChange, FormStateChangeService, StateInputFields } from '../../form-state/form-state-change.service';
import { CommonModalService } from '../../../utils/modals/common-modal.service';
import { UserDataFormService } from '../../user-data/user-data-form.service';
import { FormGroup } from '@angular/forms';
import { DeliveryModeEnum } from '../../../models/cartDetails/deliveryModeEnum.model';
import { PosPrecartPickupService } from './pos/pos-precart-pickup.service';
import { IdentityConfirmationTypeEnum } from '../../../models/cartDetails/identityConfirmationType.enum';
import { IPos } from '../../../interfaces/pos-search.interface';
import { PosFormFieldsModel } from './pos/pos-form-fields.model';
import { hiddenElementSlideInOut } from '../../../utils/animations/slides.animation';
import { FormSectionTypeEnum, FormStepsService } from '../../form-steps/form-steps.service';
import RecaptchaService from '../../recaptcha/recaptcha.service';
import { SummaryPricesService } from '../../../customer-offer/summary/summary-prices.service';
import { CommonModalTemplatesEnum } from '../../../utils/modals/common-modal-templates.enum';
import { CustomerDetailsModel } from '../../../models/customer-details.model';
import { DataLayerService } from 'src/ng2-app/scripts/customer-actions/data-layer.service';
import DeliveryModeClass from '../../../models/cartDetails/deliveryMode.model';

declare const P4: any;

@Component({
  selector: 'delivery-mode-component',
  templateUrl: './delivery-mode.component.html',
  animations: [hiddenElementSlideInOut]
})
export class DeliveryModeComponent implements OnInit, AfterContentInit {
  @Input() deliveryCost: IPrice;
  @Input() identityConfirmationType: string;
  @Input() identityConfirmationModes: IdentityConfirmationMode[];
  @Input() requiresIdentityConfirmation: boolean;

  public deliveryModesLabel: string;
  public isPlaceholderClassVisible: boolean;
  public deliveryModesList: DeliveryModeClass[];
  public selectedDeliveryModeCode: string;
  public selectedDeliveryAddressOption: string;
  public customerEmail: string;
  public showHeaderInfo = false;
  public showEmailSection = false;
  public pos: PosInterface;
  public visibility: DeliveryFormOutputState;
  public addressContent: string;
  public formFields: any;
  public formGroups: { [s: string]: FormGroup } = {};
  public deliveryMessage = 'Odbiór osobisty';
  public formSectionTypeEnum: typeof FormSectionTypeEnum = FormSectionTypeEnum;
  public isVirginBrand = false;
  public selectedPos: IPos.Marker;
  public activeForm: FormGroup;

  private readonly posFormFields = new PosFormFieldsModel();
  private readonly posFieldsNames = {};
  private valCourierNotes = '';
  private availableDeliveryModes: DeliveryMode[];

  public readonly COURIER_NOTES_MAX_LENGTH: number = 60;

  constructor(
    public formStepsService: FormStepsService,
    private deliveryPickupService: DeliveryPickupService,
    private formStateChangeService: FormStateChangeService,
    private deliveryFormStateService: DeliveryFormStateService,
    private deliveryModalService: DeliveryModalService,
    private posPrecartPickupService: PosPrecartPickupService,
    private uiService: UiHelperService,
    private notificationProvider: NotificationProviderService,
    private commonModalService: CommonModalService,
    private userDataFormService: UserDataFormService,
    private commonInfoService: CommonInfoService,
    private recaptchaService: RecaptchaService,
    private summaryPricesService: SummaryPricesService,
    private dataLayerService: DataLayerService,
    private formsGenerator: FormFieldsGeneratorService
  ) {
    this.formFields = this.userDataFormService.formFields;
    this.visibility = deliveryFormStateService.outputState;
    this.pos = this.deliveryModalService.pos;
    this.isVirginBrand = this.commonInfoService.isVirginBrand;
    const posFields = Object.keys(this.posFormFields);

    for (let i = 0; i < posFields.length; i++) {
      this.posFieldsNames['pos' + posFields[i].charAt(0).toUpperCase() + posFields[i].slice(1)] = posFields[i];
    }

    this.formsGenerator.watchActiveForm().subscribe(form => {
      this.activeForm = form;
    });
  }

  ngOnInit(): void {
    this.availableDeliveryModes = this.identityConfirmationModes[0]?.deliveryModes;
    this.prepareDeliveryModesData();
    this.prepareFormControls();

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.COMMON_INFO,
      (commonInfo: CommonInfoService) => {
        if (commonInfo) {
          this.showHeaderInfo = !commonInfo.isOtherSalesOffer;
          this.addressContent = commonInfo.b2c ? 'zamieszkania' : 'firmy';
        }
      });

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CUSTOMER_DETAILS,
      (customerData: CustomerDetailsModel) => {
        if (customerData) {
          this.customerEmail = customerData.email;
        }
      });

    this.deliveryFormStateService.subscribe((deliveryFormOutputState: DeliveryFormOutputState) => {
      this.visibility = deliveryFormOutputState;
      this.selectedDeliveryAddressOption = deliveryFormOutputState.deliveryOptionValueName;

      if (this.visibility.isPosSelected) {
        this.formStepsService.openNextSection(FormSectionTypeEnum.DELIVERY);
      }

      if (!this.visibility.isOtherAddressFormHidden && !this.visibility.isAddressOptionHidden) {
        this.formsGenerator.toggleExpandedFormGroupVisibility('deliveryAddress', this.activeForm, false, true);
      } else {
        this.formsGenerator.toggleExpandedFormGroupVisibility('deliveryAddress', this.activeForm, true);
      }
    });

    this.formStateChangeService.subscribe(async (stateChange: FormStateChange) => {
      if (stateChange.inputField === StateInputFields.IDENTITY_CONFIRMATION_TYPE) {
        this.identityConfirmationType = stateChange.value;
        this.availableDeliveryModes = this.identityConfirmationModes
          .find(item => item.code === this.identityConfirmationType).deliveryModes;
        const posMode: DeliveryMode | undefined = this.availableDeliveryModes.find(mode => mode.code === 'POS');

        if (posMode) {
          this.deliveryMessage = this.isVirginBrand
            ? 'Odbiór w punkcie'
            : this.identityConfirmationType === IdentityConfirmationTypeEnum.ONLINE || this.identityConfirmationType === IdentityConfirmationTypeEnum.M_OBYWATEL ?
              'Odbiór w punkcie (InPost, Żabki i inne)' : 'Odbiór w salonie Play';
        }

        this.resetMapData();
        this.prepareDeliveryModesData();
        this.prepareFormControls();

        await this.changeDeliveryMode();
      }
    });

    this.setPosPaymentMethodsDescription();

    setTimeout(() => {
      P4.modules.cartAddress._bindEvents();
    });
  }

  ngAfterContentInit(): void {
    this.formStepsService.setSectionVisibility(FormSectionTypeEnum.DELIVERY);
  }

  public async changeDeliveryMode(event?: Event, mode?: DeliveryMode): Promise<void> {
    event?.preventDefault();
    event?.stopPropagation();

    try {
      if (event) {
        await this.openNextSection('delivery', event);

        const freeDelivery = mode.code === DeliveryModeEnum.POS && (!this.identityConfirmationType || this.identityConfirmationType === IdentityConfirmationTypeEnum.OFFLINE);
        const selectedDeliveryCost: IPrice = mode.price === 0 || freeDelivery
          ? { net: '0.00',  gross: '0.00' }
          : this.deliveryCost;

        this.formStateChangeService.setField({
          inputField: this.formStateChangeService.StateInputFields.DELIVERY_COST,
          value: selectedDeliveryCost
        });

        if (mode.code === 'POS') {
          this.formsGenerator.toggleExpandedFormGroupVisibility('selectedPos');
          this.formsGenerator.toggleExpandedFormGroupVisibility('shippingAddress', this.activeForm, true);
        } else {
          if (this.visibility.areCorrespondenceAddressRadiobuttonsVisible) {
            this.formsGenerator.toggleExpandedFormGroupVisibility('shippingAddress', this.activeForm, false, true);
          }

          this.formsGenerator.toggleExpandedFormGroupVisibility('selectedPos', this.activeForm, true);

          if (this.selectedDeliveryAddressOption) {
            this.activeForm.get('shippingAddress').setValue(this.selectedDeliveryAddressOption);
          }
        }
      } else {
        this.activeForm.get('shippingType').setValue('');
        this.formStateChangeService.setField({
          inputField: this.formStateChangeService.StateInputFields.DELIVERY_OPTION_VALUE_NAME,
          value: ''
        });
      }
    } catch (err) {
      return;
    }

    this.selectedDeliveryModeCode = this.showEmailSection
      ? DeliveryModeEnum.EMAIL
      : this.activeForm.controls.shippingType.value;

    this.deliveryPickupService.reloadPaymentModes(this.availableDeliveryModes, this.selectedDeliveryModeCode);

    this.setFormStateDeliveryMode();

    const selectedDeliveryModeDesc: DeliveryModeClass = this.deliveryModesList.find(item => item.code === this.selectedDeliveryModeCode);

    if (selectedDeliveryModeDesc) {
      this.dataLayerService.setDeliveryPageEvent(this.showDeliveryDescription(selectedDeliveryModeDesc), 'add_shipping_info');
    }
  }

  public async changeDeliveryAddressOption(): Promise<void> {
    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.DELIVERY_OPTION_VALUE_NAME,
      value: this.activeForm.controls.shippingAddress?.value
    });

    try {
      await this.openNextSection('address');
    } catch (err) {
      return;
    }
  }

  public posDeliveryModalShow(event: Event, keyPress = false): void {
    event.preventDefault();

    const modalData = {
      templateName: CommonModalTemplatesEnum.POS_MODAL,
      pos: this.pos,
      showDeliveryOptions: this.summaryPricesService.getDevicesAndAccessoriesPrice() > 0,
      setCustomPosLocalization: (ev) => {
        this.setCustomPosLocalization(ev);
      },
      selectPos: (ev: Event, pos: IPos.Marker) => {
        this.selectPos(ev, pos);
        this.activeForm.controls.paymentOptions?.setValue('');
        this.formStateChangeService.setField({
          inputField: this.formStateChangeService.StateInputFields.PAYMENT_MODE_VALUE_NAME,
          value: ''
        });
      },
      seeOnMap: (ev: Event, pos: IPos.Marker) => {
        this.seeOnMap(ev, pos);
      },
      posDeliveryModalHide: (ev: Event) => {
        this.posDeliveryModalHide(ev);
      },
      backToList: (ev: Event, focus = false) => {
        ev.preventDefault();
        this.deliveryModalService.backToList();

        if (focus) {
          setTimeout(() => {
            document.getElementById('pos0')?.focus();
          }, 500);
        }
      },
      changeProvider: () => {
        this.deliveryModalService.searchPos();
      },
      focusPosList: () => {
        if (this.pos.activeItem) {
          document.getElementById('pos-active-item')?.focus();
        } else {
          document.getElementById('pos0')?.focus();
        }
      },
      backToFilters: (shouldChangeFocus: boolean) => {
        if (shouldChangeFocus) {
          setTimeout(() => {
            document.getElementById('modal-close-button')?.focus();
          });
        }
      },
      keyPress,
      showError: this.deliveryModalService.showError
    };

    this.commonModalService.setData(modalData);

    this.posPrecartPickupService.initialMap().then(() => {
      this.deliveryModalService.showMapModal();
    });

    this.deliveryPickupService.setSelectedPosError(false);
    this.deliveryPickupService.showSelectedPosError = false;
  }

  public posDeliveryModalHide($event: any): void {
    $event.preventDefault();

    this.commonModalService.removeModal(CommonModalTemplatesEnum.POS_MODAL);

    this.uiService.scrollToElement('posPanel');

    this.deliveryPickupService.showPosError();
  }

  public selectPos(event: Event, pos: IPos.Marker): void {
    event.preventDefault();

    if (pos === null) {
      return;
    }

    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.POS_PAYMENT_MODES,
      value: pos.paymentModes
    });

    this.deliveryPickupService.setPos(pos);

    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.SELECTED_POS,
      value: true
    });

    this.selectedPos =  this.deliveryPickupService.getSelectedPos();
    const posFields = Object.keys(this.posFieldsNames);

    for (let i = 0; i < posFields.length; i++) {
      const name = this.posFieldsNames[posFields[i]];
      this.activeForm?.controls.selectedPos?.get(posFields[i])?.setValue(this.selectedPos[name]);
    }

    this.posDeliveryModalHide(event);
  }

  public seeOnMap(event: Event, pos: IPos.Marker): void {
    event.preventDefault();

    if (pos === null) {
      return;
    }

    this.deliveryModalService.seeOnMap(pos);
  }

  public setCustomPosLocalization(event: any): void {
    event.preventDefault();
    const customLocalization = event.target.value || this.deliveryModalService.pos.customLocalization;

    this.deliveryModalService.loadPosFromCustomLocalization(customLocalization);
  }

  public checkCourierNotesLength(): void {
    this.valCourierNotes = this.activeForm.get('courierNotes').value;
    this.isPlaceholderClassVisible = !!this.valCourierNotes.length;

    if (this.valCourierNotes.length < this.COURIER_NOTES_MAX_LENGTH) {
      return;
    }

    this.valCourierNotes = this.valCourierNotes.substring(0, this.COURIER_NOTES_MAX_LENGTH);
    this.activeForm.get('courierNotes').setValue(this.valCourierNotes);
  }

  private prepareDeliveryModesData(): void {
    if (!this.requiresIdentityConfirmation &&
       (!this.identityConfirmationType || this.availableDeliveryModes.find((mode: DeliveryMode) => mode.code !== DeliveryModeEnum.EMAIL)))
    {
      this.formStepsService.openNextSection(FormSectionTypeEnum.USER_AUTHENTICATION);
    }

    this.deliveryModesList = this.prepareDeliveryModeModel(this.availableDeliveryModes);
    this.showEmailSection = !!(!this.requiresIdentityConfirmation
      && this.availableDeliveryModes.find((mode: DeliveryMode) => mode.code === DeliveryModeEnum.EMAIL));

    if (this.availableDeliveryModes.length > 1) {
      this.deliveryModesLabel = 'Wybierz sposób dostawy przesyłki:';
    } else {
      this.deliveryModesLabel = 'Sposób dostawy:';

      if (!this.showEmailSection) {
        setTimeout(() => {
          const element: HTMLElement = document.getElementById(this.availableDeliveryModes[0].code);
          (element as HTMLInputElement).click();
        });
      }
    }

    if (this.selectedDeliveryModeCode) {
      this.deliveryPickupService.reloadPaymentModes(this.availableDeliveryModes, this.selectedDeliveryModeCode);
    } else if (!this.requiresIdentityConfirmation || (this.requiresIdentityConfirmation && this.identityConfirmationType)) {
      if (this.showEmailSection) {
        this.selectedDeliveryModeCode = this.availableDeliveryModes[0].code;
      }

      setTimeout(() => {
        this.setFormStateDeliveryMode();
      });
    }
  }

  public courierNotesCharactersLeft(): number {
    return this.COURIER_NOTES_MAX_LENGTH - this.valCourierNotes.length;
  }

  public showDeliveryDescription(deliveryMode: DeliveryModeClass): string {
    return deliveryMode.code === DeliveryModeEnum.POS ? this.deliveryMessage : deliveryMode.description;
  }

  public showDeliveryCost(deliveryMode: DeliveryMode): string {
    if (this.commonInfoService.isOtherSalesOffer) return;

    return deliveryMode.code === DeliveryModeEnum.POS && (!this.identityConfirmationType || this.identityConfirmationType === IdentityConfirmationTypeEnum.OFFLINE)
      ? '0,00 zł'
      : `${this.deliveryCost[this.commonInfoService.taxName].replace('.', ',')} ${!this.commonInfoService.b2c && parseFloat(this.deliveryCost[this.commonInfoService.taxName]) > 0 ? 'zł <span class="currency-tax">+ VAT</span>' : 'zł'}`;
  }

  private setFormStateDeliveryMode(): void {
    const selectedCode = this.selectedDeliveryModeCode || '';

    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.DELIVERY_MODE_NAME,
      value: this.deliveryModesList.find((deliveryMode: DeliveryModeClass) => deliveryMode.code === selectedCode)?.code || ''
    });
  }

  private prepareDeliveryModeModel(items: DeliveryMode[]): DeliveryModeClass[] {
    const deliveryModes: DeliveryModeClass[] = [];

    items.forEach((deliveryMode: DeliveryMode) => deliveryModes.push(new DeliveryModeClass(deliveryMode)));

    return deliveryModes;
  }

  private prepareFormControls(): void {
    if (!this.showEmailSection) {
      this.formsGenerator.prepareDeliveryOptions(this.selectedDeliveryModeCode);

      this.formsGenerator.prepareDeliveryAddress({deliveryAddress: this.formFields.deliveryAddress});
    }

    const posFields = Object.keys(this.posFieldsNames);

    this.formsGenerator.prepareSelectedPos(posFields);
  }

  private deleteSelectedPos(): void {
    this.formStateChangeService.setField({
      inputField: this.formStateChangeService.StateInputFields.SELECTED_POS,
      value: false
    });

    this.selectedPos = null;
  }

  private resetMapData(): void {
    this.deleteSelectedPos();
    this.deliveryModalService.backToList();
    this.deliveryModalService.pos.selectedProvider = '';
    this.deliveryModalService.pos.customLocalization = '';
  }

  private openNextSection(inputType: 'delivery' | 'address', event?: Event) {
    return new Promise((resolve, reject) => {

      if (this.formStepsService.getSection(FormSectionTypeEnum.DELIVERY).dataChanged) {
        if (inputType === 'delivery' ) {
          this.setDeliveryElement(event, false);
          this.formStepsService.openModalConfirmation('delivery').then(() => {
            // Reset form after modal confirmation
            if (this.activeForm.get('paymentMode')) {
              this.activeForm.get('paymentMode').reset();
            }
            this.formStateChangeService.setField({
              inputField: this.formStateChangeService.StateInputFields.PAYMENT_MODE_VALUE_NAME,
              value: ''
            });
            this.formStateChangeService.setField({
              inputField: this.formStateChangeService.StateInputFields.POS_PAYMENT_MODES,
              value: ''
            });

            this.formStateChangeService.setField({
              inputField: this.formStateChangeService.StateInputFields.DELIVERY_OPTION_VALUE_NAME,
              value: ''
            });

            if (this.activeForm.get('shippingAddress')) {
              this.activeForm.get('shippingAddress').reset();
            }

            this.recaptchaService.reset();
            this.resetMapData();
            this.setDeliveryElement(event, true);
            resolve();
          }).catch(() => {
            this.setDeliveryElement(event, false);
            reject();
          });
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  private setDeliveryElement(event: any, isChange: boolean): void {
    const selectedDeliveryElement = (document.getElementById(this.selectedDeliveryModeCode)) as HTMLInputElement;
    const element = (document.getElementById(event.target.id)) as HTMLInputElement;

    element.checked = isChange;
    selectedDeliveryElement.checked = !isChange;
  }

  public setPosPaymentMethodsDescription(): void {
    const paymentMethodsDescription = {
      POS_CASH: 'Gotówka',
      POS_CARD: 'Karta',
      COD_CASH: 'Gotówka',
      COD_CARD: 'Karta',
    };

    this.deliveryModalService.posChangeSubscribe((posAll: IPos.Marker[]): void => {
      posAll.forEach((value: IPos.Marker): void => {
        value.formattedOpeningSchedule = value.openingSchedule?.replace(/\,/g, '<br>').toLowerCase();

        value.paymentMethodsDescription = [];
        value.paymentMethods?.forEach((item: string ): void => {
          if (paymentMethodsDescription[item]) {
            value.paymentMethodsDescription.push(
              {
                code: item,
                name: paymentMethodsDescription[item]
              }
            );
          }
        });
      });

      this.pos.allPos = posAll;
    });
  }
}
